export async function fetchReviews(page = 1) { //Default parameter — if no page is provided when the function is called, it uses page 1.
    const response = await fetch(`/api/reviews?page=${page}`); // if page = 2, the URL becomes /api/reviews?page=2
    if (!response.ok) {
        throw new Error('Failed to fetch reviews');
    }
    return response.json();
}

export async function fetchReviewStats() {
    const response = await fetch('/api/review-stats');
    if (!response.ok) {
        throw new Error('Failed to fetch review statistics');
    }
    return response.json();
}

export async function fetchEmployeePerformance() {
    const response = await fetch('/api/employee-performance');
    if (!response.ok) {
        throw new Error('Failed to fetch employee performance data');
    }
    return response.json();
}

export async function fetchEmployeeNLB(employeeSub) {
    const response = await fetch(`/api/employee-nlb/${employeeSub}`);
    if (!response.ok) {
        throw new Error('Failed to fetch employee NLB metrics');
    }
    return response.json();
}

export async function fetchEmployeeReviews(employeeSub) {
    const response = await fetch(`/api/employee-reviews/${employeeSub}`);
    if (!response.ok) {
        throw new Error('Failed to fetch employee reviews');
    }
    return response.json();
}








